(() => {
  const DISCOUNT_STORAGE_KEY = "aloe-quote-discount-code",
    DISCOUNTS = {
      ALOE15: { percent: 15, label: "15 % Rabatt auf deine Textilien" },
    },
    normalizeDiscountCode = (value) =>
      String(value || "")
        .trim()
        .replace(/\s+/g, "")
        .toUpperCase(),
    autumnCopy = JSON.parse(
      document.getElementById("aloe-autumn-copy")?.textContent || "{}",
    ),
    exposeDesignerLinks = (properties) => {
      const urlPattern = /https?:\/\/[^\s<>"']+/g,
        walker = document.createTreeWalker(properties, NodeFilter.SHOW_TEXT),
        textNodes = [];
      for (; walker.nextNode(); ) {
        const node = walker.currentNode;
        (!node.parentElement?.closest("a") &&
          urlPattern.test(node.nodeValue || "") &&
          textNodes.push(node),
          (urlPattern.lastIndex = 0));
      }
      (textNodes.forEach((node) => {
        const text = node.nodeValue || "",
          fragment = document.createDocumentFragment();
        let cursor = 0;
        (text.replace(urlPattern, (url, offset) => {
          fragment.append(text.slice(cursor, offset));
          const link = document.createElement("a");
          return (
            (link.href = url),
            (link.target = "_blank"),
            (link.rel = "noopener"),
            (link.className = "aloe-quote-file-link"),
            (link.textContent = /gestaltungsansicht|designer-mockup/i.test(text)
              ? "Mockup ansehen"
              : "Originaldatei \xF6ffnen"),
            fragment.append(link),
            (cursor = offset + url.length),
            url
          );
        }),
          fragment.append(text.slice(cursor)),
          node.replaceWith(fragment),
          (urlPattern.lastIndex = 0));
      }),
        properties
          .querySelectorAll('a[href*="/uploads/"], a[href*="cdn.shopify.com"]')
          .forEach((link) => {
            ((link.target = "_blank"),
              (link.rel = "noopener"),
              link.classList.add("aloe-quote-file-link"));
            const context = link.parentElement?.textContent || "";
            link.textContent = /gestaltungsansicht|designer-mockup/i.test(
              context,
            )
              ? "Mockup ansehen"
              : "Originaldatei \xF6ffnen";
          }));
    };
  try {
    localStorage.removeItem(DISCOUNT_STORAGE_KEY);
  } catch {}
  if (!location.pathname.startsWith("/apps/request-quote")) return;
  const addDiscountField = (form) => {
      if (form.querySelector("[data-aloe-discount]")) return;
      const remarksWrapper = form.querySelector("#quote-remarks-wrapper"),
        remarks = remarksWrapper?.querySelector("textarea, input");
      if (!remarksWrapper || !remarks) return;
      const wrapper = document.createElement("section");
      ((wrapper.className = "aloe-quote-discount"),
        (wrapper.dataset.aloeDiscount = ""),
        (wrapper.innerHTML = `
      <div class="aloe-quote-discount__heading">
        <span class="aloe-quote-discount__icon" aria-hidden="true">%</span>
        <div>
          <strong>Rabattcode</strong>
          <span>Code aus einer Aktion oder Meta-Anzeige einl\xF6sen.</span>
        </div>
      </div>
      <div class="aloe-quote-discount__controls">
        <label class="visually-hidden" for="AloeQuoteDiscount">Rabattcode</label>
        <input id="AloeQuoteDiscount" type="text" inputmode="text" autocomplete="off" spellcheck="false" placeholder="z. B. ALOE15" maxlength="30">
        <button type="button">Anwenden</button>
      </div>
      <p class="aloe-quote-discount__message" aria-live="polite"></p>
      <small>Der Rabatt gilt f\xFCr Textilpreise. Druck-, Stick- und sonstige Veredelungskosten werden separat kalkuliert.</small>
    `),
        remarksWrapper.before(wrapper),
        autumnCopy.terms &&
          (wrapper.querySelector("small").textContent = autumnCopy.terms));
      const input = wrapper.querySelector("input"),
        button = wrapper.querySelector("button"),
        message = wrapper.querySelector(".aloe-quote-discount__message"),
        markerPattern = /(?:^|\n)\[Rabattcode: [^\]]+\]\n?/g,
        syncRemarks = (code) => {
          const cleanNotes = remarks.value.replace(markerPattern, "").trim(),
            marker = code
              ? `[Rabattcode: ${code} \u2013 ${DISCOUNTS[code].percent} % auf nicht bereits rabattierte Textilien; ohne Veredelung, Einrichtung und Versand; nicht kombinierbar; im Angebot abziehen]`
              : "";
          ((remarks.value = [marker, cleanNotes].filter(Boolean).join(`
`)),
            remarks.dispatchEvent(new Event("input", { bubbles: !0 })),
            remarks.dispatchEvent(new Event("change", { bubbles: !0 })));
        },
        apply = (silent = !1) => {
          const code = normalizeDiscountCode(input.value);
          if (
            ((input.value = code),
            wrapper.classList.remove("is-valid", "is-invalid"),
            !code)
          ) {
            (syncRemarks(""), (message.textContent = ""));
            try {
              localStorage.removeItem(DISCOUNT_STORAGE_KEY);
            } catch {}
            return;
          }
          if (!DISCOUNTS[code]) {
            (syncRemarks(""),
              wrapper.classList.add("is-invalid"),
              (message.textContent =
                autumnCopy.invalid ||
                "Dieser Rabattcode ist nicht g\xFCltig. Bitte pr\xFCfe die Schreibweise."));
            try {
              localStorage.removeItem(DISCOUNT_STORAGE_KEY);
            } catch {}
            return;
          }
          (syncRemarks(code),
            wrapper.classList.add("is-valid"),
            (message.textContent =
              autumnCopy.valid ||
              `\u2713 ${code} ist vorgemerkt: ${DISCOUNTS[code].label}.`));
          try {
            localStorage.setItem(DISCOUNT_STORAGE_KEY, code);
          } catch {}
          silent || input.blur();
        };
      (button.addEventListener("click", () => apply()),
        input.addEventListener("keydown", (event) => {
          event.key === "Enter" && (event.preventDefault(), apply());
        }),
        input.addEventListener("input", () => {
          (syncRemarks(""),
            wrapper.classList.remove("is-valid", "is-invalid"),
            (message.textContent = ""));
        }));
      const ensureDiscountIsSynced = () => {
        apply(!0);
      };
      (form.addEventListener("submit", ensureDiscountIsSynced, !0),
        form
          .closest("form")
          ?.addEventListener("submit", ensureDiscountIsSynced, !0),
        form
          .querySelector("#submit-quote")
          ?.addEventListener("click", ensureDiscountIsSynced, !0));
    },
    enhance = () => {
      const root = document.querySelector("#quick-quote-wrapper"),
        heading = document.querySelector("#qq-header"),
        panel = document.querySelector("#pnl-request-quote-wrapper"),
        form = panel?.querySelector(".quote-form"),
        summary = panel?.querySelector("#qq-table-wrapper");
      if (
        !root ||
        !heading ||
        !panel ||
        !form ||
        !summary ||
        root.dataset.aloeEnhanced
      )
        return !1;
      ((root.dataset.aloeEnhanced = "true"),
        document.body.classList.add("aloe-quote-page"));
      const intro = document.createElement("div");
      intro.className = "aloe-quote-intro";
      const eyebrow = document.createElement("div");
      ((eyebrow.className = "aloe-quote-eyebrow"),
        (eyebrow.textContent = "Schritt 2 von 3"));
      const lead = document.createElement("p");
      ((lead.className = "aloe-quote-lead"),
        (lead.textContent =
          "Nur noch deine Kontaktdaten erg\xE4nzen. Danach pr\xFCfen wir die Zusammenstellung und senden dir das vollst\xE4ndige Angebot per E-Mail."));
      const progress = document.createElement("div");
      ((progress.className = "aloe-quote-progress"),
        progress.setAttribute("aria-label", "Fortschritt deiner Anfrage"),
        (progress.innerHTML =
          '<span class="is-done"><b>\u2713</b>Produkte ausgew\xE4hlt</span><span class="is-active"><b>2</b>Kontaktdaten</span><span><b>3</b>Angebot per E-Mail</span>'),
        heading.before(intro),
        intro.append(eyebrow, heading, lead, progress));
      const formTitle = document.createElement("h2");
      ((formTitle.className = "aloe-quote-form-title"),
        (formTitle.textContent = "Wohin d\xFCrfen wir dein Angebot senden?"));
      const formNote = document.createElement("p");
      ((formNote.className = "aloe-quote-form-note"),
        (formNote.textContent =
          "Mit * markierte Angaben ben\xF6tigen wir f\xFCr die R\xFCckmeldung."),
        form.prepend(formNote),
        form.prepend(formTitle));
      const hasSavedContact =
        (window.AloeQuoteCustomer || {}).loggedIn &&
        ["#txtFirstName", "#txtLastName", "#txtEmail"].every((selector) =>
          form.querySelector(selector)?.value.trim(),
        );
      if (hasSavedContact) {
        (form.classList.add("aloe-customer-quote", "is-customer-compact"),
          (formTitle.textContent = "Deine Angaben sind schon hinterlegt"),
          (formNote.textContent =
            "Du bist angemeldet und musst deine Kontaktdaten nicht erneut eingeben."));
        const account = document.createElement("section");
        ((account.className = "aloe-quote-account"),
          account.setAttribute("aria-label", "Gespeicherte Kontaktdaten"));
        const accountIcon = document.createElement("span");
        ((accountIcon.className = "aloe-quote-account-icon"),
          (accountIcon.textContent = "\u2713"));
        const accountCopy = document.createElement("div"),
          accountName = document.createElement("strong"),
          existingFirstName = form.querySelector("#txtFirstName")?.value.trim(),
          existingLastName = form.querySelector("#txtLastName")?.value.trim(),
          existingEmail = form.querySelector("#txtEmail")?.value.trim();
        accountName.textContent =
          [existingFirstName, existingLastName].filter(Boolean).join(" ") ||
          "Angemeldetes Kundenkonto";
        const accountEmail = document.createElement("span");
        ((accountEmail.textContent =
          existingEmail || "Kontaktdaten sind bei Quick Quote hinterlegt"),
          accountCopy.append(accountName, accountEmail));
        const edit = document.createElement("button");
        ((edit.type = "button"),
          (edit.className = "aloe-quote-account-edit"),
          (edit.textContent = "Andere Angaben verwenden"),
          edit.setAttribute("aria-expanded", "false"),
          edit.addEventListener("click", () => {
            const compact = form.classList.toggle("is-customer-compact");
            ((edit.textContent = compact
              ? "Andere Angaben verwenden"
              : "Angaben wieder einklappen"),
              edit.setAttribute("aria-expanded", String(!compact)));
          }),
          account.append(accountIcon, accountCopy, edit),
          formNote.after(account),
          form
            .querySelectorAll(".quote-input-group:not(#quote-remarks-wrapper)")
            .forEach((group) => {
              group.classList.add("aloe-customer-contact-field");
            }));
        const remarksLabel = form.querySelector(
          "#quote-remarks-wrapper .quote-input-label",
        );
        remarksLabel &&
          (remarksLabel.textContent =
            "Zus\xE4tzliche W\xFCnsche oder Hinweise (optional)");
      }
      const autocomplete = {txtFirstName: "given-name", txtLastName: "family-name", txtEmail: "email", txtPhone: "tel", customField9456: "organization", customField9457: "street-address", customField9458: "postal-code", customField9459: "address-level2"};
      form.querySelectorAll(".quote-input-group").forEach(group => {
        const label = group.querySelector(".quote-input-label");
        const input = group.querySelector('input:not([type="hidden"]),textarea,select');
        if (!label || !input || !input.id) return;
        if (!label.id) label.id = `aloe-label-${input.id}`;
        input.setAttribute("aria-labelledby", label.id);
        input.setAttribute("aria-required", String(label.textContent.includes("*")));
        if (autocomplete[input.id]) input.setAttribute("autocomplete", autocomplete[input.id]);
        if (input.id === "txtEmail") input.setAttribute("inputmode", "email");
        if (input.id === "txtPhone") input.setAttribute("inputmode", "tel");
      });
      addDiscountField(form);
      const required = form.querySelector(".quote-required-message");
      required && (required.hidden = !0);
      const summaryTitle = document.createElement("h2");
      ((summaryTitle.className = "aloe-quote-summary-title"),
        (summaryTitle.textContent = "Deine Auswahl"));
      const summaryNote = document.createElement("p");
      ((summaryNote.className = "aloe-quote-summary-note"),
        (summaryNote.textContent =
          "Alle Produkte und Gestaltungsangaben sind gespeichert."),
        summary.prepend(summaryNote),
        summary.prepend(summaryTitle),
        summary
          .querySelectorAll(".cart_item_properties")
          .forEach((properties) => {
            if (properties.textContent.trim()) {
              exposeDesignerLinks(properties);
              const saved = document.createElement("span");
              ((saved.className = "aloe-quote-saved"),
                (saved.textContent = "\u2713 Konfiguration gespeichert"),
                properties.after(saved));
            }
          }));
      const submit = form.querySelector(
        "#submit-quote .ng-binding, #submit-quote span",
      );
      submit &&
        (submit.textContent = hasSavedContact
          ? "Anfrage jetzt senden"
          : "Unverbindliche Anfrage senden");
      const back = form.querySelector(
        "#back-to-cart .ng-binding, #back-to-cart span",
      );
      return (
        back && (back.textContent = "\u2190 Auswahl noch einmal \xE4ndern"),
        !0
      );
    };
  if (!enhance()) {
    const observer = new MutationObserver(() => {
      enhance() && observer.disconnect();
    });
    (observer.observe(document.documentElement, { childList: !0, subtree: !0 }),
      window.setTimeout(() => observer.disconnect(), 15e3));
  }
})();
